<div class="flex flex-col h-full bg-gray-50">
  <!-- Header -->
  <app-chat-header (backClicked)="goBack()"></app-chat-header>

  <!-- Loading state -->
  @if (isLoading$ | async) {
    <app-chat-loading></app-chat-loading>
  }

  <!-- Error state -->
  @if (error$ | async; as error) {
    <app-chat-error [error]="error" (retryClicked)="retry()"></app-chat-error>
  }

  <!-- Messages and input -->
  @if (!(isLoading$ | async) && !(error$ | async)) {
    <app-chat-messages-list
      [messages]="(messages$ | async) ?? []"
      [isSending]="!!(isSending$ | async)"
    ></app-chat-messages-list>

    <!-- Try examples button -->
    @if (showExamplesLink$ | async) {
      <div class="max-w-3xl mx-auto w-full px-4 py-2">
        <div class="flex items-center justify-between gap-2 text-sm text-gray-500">
          <span>Don't have student work nearby?</span>
          <button
            type="button"
            (click)="onExamplesRequested()"
            class="flex items-center gap-1.5 text-violet-600 bg-violet-50 hover:bg-violet-100 px-3 py-1.5 rounded-full border border-violet-200 hover:border-violet-300 transition-colors cursor-pointer font-medium whitespace-nowrap"
          >
            <lucide-icon [img]="icons.FileImage" class="w-4 h-4"></lucide-icon>
            Use our sample files
          </button>
        </div>
      </div>
    }

    <!-- Input -->
    <div class="max-w-3xl mx-auto w-full">
      <app-chat-input
        #chatInput
        [disabled]="!!(isSending$ | async)"
        [placeholder]="'Type your message...'"
        [pendingAttachments]="(pendingAttachments$ | async) ?? []"
        (messageSent)="onMessageSent($event)"
        (filesSelected)="onFilesSelected($event)"
        (attachmentRemoved)="onAttachmentRemoved($event)"
      ></app-chat-input>
    </div>
  }
</div>
